import { Rates } from "@/api/services/next";
import { useEffect, useRef, useState } from "react";
import { List } from "semantic-ui-react";
import CopyRateResultCard from "../../components/CopyRateResultCard";
import { useLoader } from "@hooks/useLoader";

const Results = ({ state, setState }) => {
  const [copyResults, setCopyResults] = useState([]);
  const ranOnceRef = useRef(false);
  const loader = useLoader();

  useEffect(() => {
    if (ranOnceRef.current) return;
    ranOnceRef.current = true;
    
    const copyRequest = {
      sourceCopyRateId: state.SourceCopyRateId,
      components: Object.entries(state.Components)
        .filter(([, v]) => v)
        .map(([k]) => k),
      targetHotelIds: state.TargetHotelIds,
      rateCustomNames: state.RateCustomNames,
    };
    const copyRates = async () => {
      try {
        loader(true);
        const results = await Rates.CopyRate(copyRequest);
        setCopyResults(results);
        setState((prev) => ({
          ...prev,
          completedSteps: [...(prev.completedSteps || []), 2],
        }));
      } catch (error) {
        console.error("Error copying rates:", error);
      } finally {
        loader(false);
      }
    };

    copyRates();
  }, []); /* I want this to run only once on mount to prevent double execution */

  return (
    <List relaxed>
      {copyResults.map(({ HotelId, NewRate, Success }, index) => (
        <List.Item key={index}>
          <CopyRateResultCard
            rate={NewRate}
            success={Success}
            hotelName={
              state.Hotels.find((h) => h.Id === HotelId)?.Name ??
              "Unknown Hotel"
            }
          />
        </List.Item>
      ))}
    </List>
  );
};

export default Results;
